import { render } from "./ExerciseSolutionContainer.vue?vue&type=template&id=16c6d474&ts=true"
import script from "./ExerciseSolutionContainer.vue?vue&type=script&lang=ts"
export * from "./ExerciseSolutionContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__